var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.dialogVisible,
        center: "",
        direction: "ltr",
        size: "1200px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "titleName" }, [
                  _vm._v(_vm._s(_vm.$t("GlobalSetObj.bagNumber"))),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "titleName",
                    staticStyle: { "margin-left": "15px" },
                  },
                  [_vm._v(_vm._s(_vm.detailObj.bagNumber))]
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          staticClass: "warp",
          staticStyle: {
            padding: "0 20px",
            height: "calc(100vh - 80px)",
            overflow: "auto",
          },
        },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("routes.packageConsolidationDetails"),
                    name: "1",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "line-height": "28px",
                        "margin-bottom": "10px",
                      },
                    },
                    [
                      _c("div", [
                        _c("span", { staticClass: "detailLabel" }, [
                          _vm._v(
                            _vm._s(_vm.$t("routes.CollectionTime")) + ": "
                          ),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.detailObj.baggingTime || "--")),
                        ]),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "detailLabel" }, [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.operationType")) +
                              ": "
                          ),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.detailObj.operationType || "--")),
                        ]),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "detailLabel" }, [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.businessT")) + ": "
                          ),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.detailObj.businessType || "--")),
                        ]),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "detailLabel" }, [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.NumberPackages")) +
                              ": "
                          ),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.detailObj.packageCount || "--")),
                        ]),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "detailLabel" }, [
                          _vm._v(
                            _vm._s(_vm.$t("routes.consolidationOperator")) +
                              ": "
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.detailObj.operationUserName || "--")
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "detailLabel" }, [
                          _vm._v(
                            _vm._s(_vm.$t("routes.consolidationOperationHub")) +
                              ": "
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.detailObj.operationSiteName || "--")
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    _vm._l(
                      _vm.detailObj.transportRecords,
                      function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              "line-height": "28px",
                              "margin-bottom": "10px",
                            },
                          },
                          [
                            _c("div", { staticClass: "detailLabel" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("routes.transportationCount01"))
                                ),
                              ]),
                              _c("span", [_vm._v(_vm._s("" + (index + 1)))]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("routes.transportationCount02"))
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "detailLabel" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "collectionCenter.loadingScanningTime"
                                    )
                                  ) + ": "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(item.scanTime || "--")),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "detailLabel" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("routes.loadingCompletionTime")
                                  ) + ": "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(item.loadTime || "--")),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "detailLabel" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("routes.loadingOperator")) +
                                    ": "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(item.loadUserName || "--")),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "detailLabel" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("GlobalSetObj.licensePlateNumber")
                                  ) + ": "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(item.vehicleNumber || "--")),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "detailLabel" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("GlobalSetObj.nextStation")) +
                                    ": "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(item.nextSiteName || "--")),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "detailLabel" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("GlobalSetObj.unCarTime")) +
                                    ": "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(item.unloadTime || "--")),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "detailLabel" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("routes.unloadingOperator")) +
                                    ": "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(item.unloadUserName || "--")),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "detailLabel" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("collectionCenter.unloadDot")) +
                                    ": "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(item.unloadSiteName || "--")),
                              ]),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("collectionCenter.infoPackage"),
                    name: "2",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { "margin-bottom": "10px", display: "flex" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "selectLabel" },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.searchForm.params.selectType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm.params,
                                    "selectType",
                                    $$v
                                  )
                                },
                                expression: "searchForm.params.selectType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.waybillNumber"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.ScanNumber"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("newOrder.PreciseSearch1"),
                              rows: 1,
                              clearable: "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.searchForm.params.inputValue,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchForm.params,
                                  "inputValue",
                                  $$v
                                )
                              },
                              expression: "searchForm.params.inputValue",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { margin: "32px 0 0 10px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.getSearch },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "info" },
                              on: { click: _vm.resetForm },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "success" },
                              on: { click: _vm.exportToExcel },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        "header-cell-style": {
                          background: "#f2f2f2",
                          color: "black",
                        },
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.serial"),
                          align: "center",
                          type: "index",
                          width: "80",
                        },
                      }),
                      _vm._l(_vm.tableHeaderList, function (item) {
                        return _c("el-table-column", {
                          key: item.id,
                          attrs: {
                            label: item.label,
                            "min-width": item.cloWidth,
                            prop: item.prop,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row[item.prop]
                                            ? "" + scope.row[item.prop]
                                            : "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c("el-pagination", {
                        staticStyle: { margin: "15px 0" },
                        attrs: {
                          "current-page": _vm.searchForm.pageNumber,
                          "page-size": _vm.searchForm.pageSize,
                          "page-sizes": [10, 20, 50, 100],
                          total: _vm.total,
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "pageNumber",
                              $event
                            )
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "pageNumber",
                              $event
                            )
                          },
                          "update:pageSize": function ($event) {
                            return _vm.$set(_vm.searchForm, "pageSize", $event)
                          },
                          "update:page-size": function ($event) {
                            return _vm.$set(_vm.searchForm, "pageSize", $event)
                          },
                          "current-change": _vm.getSearch,
                          "size-change": _vm.getSearch,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }